import React from 'react';
import TextField from '@material-ui/core/TextField';
import {isUndefined} from 'lodash'
import InputMask from "react-input-mask";
import {useSelector} from 'react-redux'
import { injectIntl } from 'react-intl';

function EmailInput(props) {
    const [Value,setValue] = React.useState(props.Value)
    const Flags = useSelector(state=>state.accountsData.Flags) 
    const Telephoneplaceholder = props.intl.formatMessage({ id: 'userProfile.Telephone' });
    //const [Error,setError] = React.useState(isUndefined(props.error)?false:props.error)

   // const authUser = useSelector(state => state.auth.authUser)

    /*const onchangeHandle=(e)=>{
      
        setValue(e.target.value)
    }*/
    /*const onBlurHandle=()=>{
     //   if(Error === false){
            let Tele=TeleFormat(Value) 
            props.onchangeHanelEvent("Tele",Tele)
            setValue(Tele)
      //  }
    }*/
    React.useEffect(()=>{
        let Tele=TeleFormat(props.Value)
        props.onchangeHanelEvent("Tele",Tele)
        setValue(Tele)
    },[props.Value])
    const TeleFormat=(Tele)=>{
      let LandCode = Flags.BolagData === "NO"?"+47":"+46"
        Tele = String(Tele).replace(/[^\d+]+/g,'')
        Tele = Tele.split(" ").join("")
        Tele = Tele.split("-").join("")
      //  console.log(Tele,"DDDD")
        let Tele1=''
        if(parseInt(Tele[0]) === 0){
          Tele = Tele.substring(1)
        }
        let Tele2=Tele
        switch(true){
            case Tele[0] === '+':
                Tele2=`${Tele}`
                break;
            case Tele.length < 10:
                Tele2=`${LandCode}${Tele}`
                break;
            case Tele.length < 11:
                Tele1 = Tele.substring(1)
                Tele2=`${LandCode}${Tele1}`
                break;
            case Tele.length < 12:
                Tele1 = Tele.substring(2)
                Tele2=`${LandCode}${Tele1}`
                break;
            case Tele.length < 13:
                if(Tele[0] === "+"){
                    Tele2=`${Tele}`
                }else{
                    Tele1 = Tele.substring(3)
                    Tele2=`${LandCode}${Tele1}`
                }                
                break;
            case Tele.length < 14:
                    Tele1 = Tele.substring(2)
                    Tele2=`+${Tele1}`
                break;
                default:Tele2=Tele
        }
        return Tele2
    }
    // if(authUser.user_Afid === 1001) {
      return (
        <InputMask
        mask={`+999 99 999 99 99`}
          alwaysShowMask={true}
          value={Value}
          defaultValue={props.Value}
          disabled={false}
          maskChar=" "
          onChange={(event) => {
            setValue(event.target.value)
          }}
          onBlur={(event) => {
            props.onchangeHanelEvent("Tele",(event.target.value).replace(/\s/g, ''))
          }}
        >
        { () => <TextField
          error={props.error}
          size="small"
          label={`${Telephoneplaceholder} (${Flags.BolagData === "NO"?"+47":"+46"}...):`}
          fullWidth
          variant="outlined"
        />}
        </InputMask>
      )
  
}
export default injectIntl(EmailInput);